import PropTypes from 'prop-types'
import { useState, useEffect, useCallback } from 'react'
import { toastErrorLog } from '../../helpers/toastErrorLog'
import { useAuth } from '../../hooks/useAuth'
import { withValidador } from '../hoc/withValidador'
import { useDomicilioPrincipalEBM } from '../hooks/useDomicilioPrincipalEBM.js'
import ImagenDni from '../imagen/ImagenDni'
import * as usuarioService from '../servicios/usuarioService'
import InputEditable from '../ui/InputEditable'
import styles from './Perfil.module.css'

const DatosPersonales = (props) => {
  const [datos, setDatos] = useState([])
  const [errores, setErrores] = useState({})
  const { loginDataContext: { idUsuario, tipoUsuario, tipo } = {} } = useAuth()

  const { domicilioPrincipalEBM, domicilioEBMEstaCompleto } = useDomicilioPrincipalEBM(idUsuario)
  const { calle, calleAltura, localidad, provincia } = domicilioPrincipalEBM || {}
  const esquema = {
    cuit: props.Validador.Kernel.string()
      .trim()
      .required()
      .error((e) => {
        return props.Validador.mensaje(e, {
          'any.empty': <>El número de CUIT no puede quedar vacío</>
        })
      }),
    email: props.Validador.Kernel.string()
      .trim()
      .required()
      .error((e) => {
        return props.Validador.mensaje(e, {
          'any.empty': <>La dirección de e-mail no puede quedar vacía</>
        })
      }),
    telefono: props.Validador.Kernel.number()
      .empty(0)
      .required()
      .error((e) => {
        return props.Validador.mensaje(e, {
          'any.required': <>El número de teléfono no puede quedar vacío</>
        })
      }),
    celular: props.Validador.Kernel.number()
      .empty(0)
      .required()
      .error((e) => {
        return props.Validador.mensaje(e, {
          'any.required': <>El número de celular no puede quedar vacío</>
        })
      })
  }

  const searchMethod = useCallback(async () => {
    if (!idUsuario) return
    const { data: datos } = await usuarioService.buscarPorId(idUsuario)
    setDatos(datos)
  }, [idUsuario])

  useEffect(() => {
    searchMethod()
  }, [searchMethod])

  useEffect(() => {
    if (props.buscar) {
      searchMethod()
    }
  }, [props.buscar, searchMethod])

  const validarCampo = useCallback(
    (name) => {
      const errores = props.Validador.validarDato(
        esquema,
        {
          cuit: datos.cuit,
          email: datos.email,
          telefono: datos.telefono,
          celular: datos.celular
        },
        name
      )

      setErrores(errores || {})
      if (errores) {
        return false
      } else {
        return true
      }
    },
    [datos, props.Validador, esquema]
  )

  const handleClickOutSide = async (name) => {
    try {
      if (validarCampo(name)) {
        const usuarioDatoNuevo = {
          idUsuario,
          usrId: datos.usrId,
          razonSocial: datos.razonSocial,
          cuit: datos.cuit,
          email: datos.email,
          telefono: datos.telefono,
          celular: datos.celular
        }
        await usuarioService.actualizar(usuarioDatoNuevo)
      }
    } catch (error) {
      const mensaje = `Ocurrió un error al guardar los datos.`
      toastErrorLog(error, mensaje, 'usuario')
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setDatos((prevDatos) => ({
      ...prevDatos,
      [name]: value
    }))
    validarCampo(name)
  }

  const esUsuarioParticular = tipoUsuario === 'R'

  return (
    <div className={styles.sectionsGrid}>
      <div className={styles.card}>
        <h3 className={styles.cardTitle}>Datos Personales</h3>
        <ul className={styles.fieldList}>
          <li className={styles.fieldRow}>
            <span className={styles.fieldLabel}>Nombre:</span>
            <span className={styles.fieldValue}>{datos.nombre}</span>
          </li>
          <li className={styles.fieldRow}>
            <span className={styles.fieldLabel}>Apellido:</span>
            <span className={styles.fieldValue}>{datos.apellido}</span>
          </li>
          <li className={styles.fieldRow}>
            <span className={styles.fieldLabel}>DNI:</span>
            <span className={styles.fieldValue}>{datos.dni}</span>
          </li>
          {tipo === 'P' && (
            <>
              <ImagenDni idUsuario={idUsuario} idTipo={1} download={true}></ImagenDni>
              <ImagenDni idUsuario={idUsuario} idTipo={2} download={true}></ImagenDni>
            </>
          )}
          <li className={`${styles.fieldRow} ${esUsuarioParticular ? styles.editable : ''}`}>
            <span className={styles.fieldLabel}>Empresa:</span>
            {!esUsuarioParticular ? (
              <span className={styles.fieldValue}>{datos.razonSocial}</span>
            ) : (
              <InputEditable
                type="text"
                name="razonSocial"
                placeholder=""
                onChange={handleChange}
                texto={datos.razonSocial || ''}
                value={datos.razonSocial}
                classInput="input-editable-perfil"
                classLabel={styles.fieldValue}
                onClickOutSide={handleClickOutSide}
                maxLength={100}
                errores={errores}
              />
            )}
          </li>
          <li className={`${styles.fieldRow} ${esUsuarioParticular ? styles.editable : ''}`}>
            <span className={styles.fieldLabel}>CUIT:</span>
            {!esUsuarioParticular ? (
              <span className={styles.fieldValue}>{datos.cuit}</span>
            ) : (
              <InputEditable
                type="text"
                name="cuit"
                placeholder=""
                onChange={handleChange}
                texto={datos.cuit || ''}
                value={datos.cuit}
                classInput="input-editable-perfil"
                classLabel={styles.fieldValue}
                onClickOutSide={(e, name) => handleClickOutSide(name)}
                errores={errores}
                disabled
              />
            )}
          </li>
        </ul>
      </div>
      <div className={styles.card}>
        <h3 className={styles.cardTitle}>Datos Usuario</h3>
        <ul className={styles.fieldList}>
          <li className={styles.fieldRow}>
            <span className={styles.fieldLabel}>Nombre Usuario:</span>
            <span className={styles.fieldValue}>{datos.usrId}</span>
          </li>
          <li className={`${styles.fieldRow} ${esUsuarioParticular ? styles.editable : ''}`}>
            <span className={styles.fieldLabel}>E-mail:</span>
            {!esUsuarioParticular ? (
              <span className={styles.fieldValue}>{datos.email}</span>
            ) : (
              <InputEditable
                type="text"
                name="email"
                placeholder=""
                onChange={handleChange}
                texto={datos.email || ''}
                value={datos.email}
                classInput="input-editable-perfil"
                classLabel={styles.fieldValue}
                onClickOutSide={(e, name) => handleClickOutSide(name)}
                errores={errores}
              />
            )}
          </li>
          <li className={`${styles.fieldRow} ${esUsuarioParticular ? styles.editable : ''}`}>
            <span className={styles.fieldLabel}>Teléfono:</span>
            {!esUsuarioParticular ? (
              <span className={styles.fieldValue}>{datos.telefono}</span>
            ) : (
              <InputEditable
                type="text"
                name="telefono"
                placeholder=""
                onChange={handleChange}
                texto={datos.telefono || ''}
                value={datos.telefono}
                disabled={!esUsuarioParticular}
                classInput="input-editable-perfil"
                classLabel={styles.fieldValue}
                onClickOutSide={(e, name) => handleClickOutSide(name)}
                errores={errores}
              />
            )}
          </li>
          <li className={`${styles.fieldRow} ${esUsuarioParticular ? styles.editable : ''}`}>
            <span className={styles.fieldLabel}>Celular:</span>
            {!esUsuarioParticular ? (
              <span className={styles.fieldValue}>{datos.celular}</span>
            ) : (
              <InputEditable
                type="text"
                name="celular"
                placeholder=""
                onChange={handleChange}
                texto={datos.celular || ''}
                value={datos.celular}
                disabled={!esUsuarioParticular}
                classInput="input-editable-perfil"
                classLabel={styles.fieldValue}
                onClickOutSide={(e, name) => handleClickOutSide(name)}
                errores={errores}
              />
            )}
          </li>
          <li className={`${styles.fieldRow}`}>
            <span className={styles.fieldLabel}>Domicilio:</span>
            <span className={styles.fieldValue}>
              {domicilioEBMEstaCompleto
                ? `${calle} ${calleAltura}, ${localidad}, ${provincia}`
                : ''}
            </span>
          </li>
        </ul>
      </div>
    </div>
  )
}

DatosPersonales.propTypes = {
  Validador: PropTypes.shape({
    Kernel: PropTypes.object,
    validarDato: PropTypes.func,
    mensaje: PropTypes.func
  }).isRequired,
  buscar: PropTypes.bool
}

export default withValidador(DatosPersonales)
